<template>
	<div class="ms-toolbar-camera">
		<div class="toolbar-camera">
			<v-btn flat min-width="30px" @click="onClickOpenFile"><v-icon>image</v-icon></v-btn>
			<v-btn flat min-width="30px" @click="onClickResolutionMenu" color="#161" class="font-weight-bold">{{ cameraResolutionCaption }}</v-btn>
			<div class="menu-list-group" v-if="is_opened_camera_resolution_list">
				<v-btn flat block class="menu-list-item" @click="onClickResolution(true)">高画質</v-btn>
				<v-btn flat block class="menu-list-item" @click="onClickResolution(false)">標準</v-btn>
			</div>
		</div>
		<input id="input-folder" type="file" accept="image/jpeg" @click="onClickFile" @change="onChangeFile" multiple />
	</div>
</template>
<script>
import MouseState from '../../classes/MouseState';
import MouseStateMachine from '../../classes/MouseStateMachine';
export default {
	data() {
		const state_default = new MouseState({
			down: (e) => {
				let obj = e.targetTouches ? e.targetTouches[0] : e;
				if(!obj.target.closest('.toolbar-camera > .menu-list-group')){
					this.is_opened_camera_resolution_list = false;
				}
			},
		});
		return {
			msm: new MouseStateMachine(state_default),
			is_opened_camera_resolution_list: false,
		};
	},
	props: [
		'resolution',
	],
	methods: {
		onClickFile: function(e) {
			e.target.value = '';
		},
		onClickOpenFile: function() {
			this.$emit('click-open-file', () => {
				document.getElementById('input-folder').click();
			});
		},
		onClickResolutionMenu: function() {
			this.is_opened_camera_resolution_list = !this.is_opened_camera_resolution_list;
		},
		onClickResolution: function(original) {
			this.is_opened_camera_resolution_list = false;
			this.$emit('change-resolution', original);
		},
		onChangeFile: function(e) {
			this.$emit('change-file', e);
		},
	},
	computed: {
		cameraResolutionCaption: function() {
			if (this.resolution)
				return '高画質';
			else
				return '標準';
		},
	},
	mounted() {
		this.msm.bind(window);
	},
	beforeDestroy() {
		this.msm.unbind();
	},
};
</script>
<style>
	.ms-toolbar-camera .toolbar-camera {
		position: fixed;
		right: .5em;
		bottom: 1em;
		background-color: #9f9;
		border: 1px solid #3a3;
		border-radius: 2em;
		padding: 0 1em;
	}

	.ms-toolbar-camera .toolbar-camera > .v-btn {
		min-width: 2.5em;
		width: 3em;
		margin: 0;
	}

	.ms-toolbar-camera .toolbar-camera .menu-list-group {
		top: -7.5em;
		width: 8em;
	}

	.ms-toolbar-camera .toolbar-camera .menu-list-item {
		height: 2em;
		margin: 0;
	}

	.ms-toolbar-camera input[type=file] {
		opacity: 0;
		position: absolute;
		top: 0;
		left: 0;
	}
</style>
